import AnalyticsIcon from '@mui/icons-material/Analytics';

const icons = {
  AnalyticsIcon
};

const networkmis = {
  id: 'networkmis',
  type: 'group',
  children: [
    {
      id: 'anmis',
      title: 'Master MIS',
      type: 'item',
      url: '/network-MIS-report',
      icon: icons.AnalyticsIcon,
    }
  ]
};

export default networkmis;
